import { WLThemeStylesWidget } from '@sravni/cosago-react-library/lib/components';
import type { ThemeNames } from '@sravni/design-system-theme';
import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib/redux';

import { whiteLabelAffIdSelector, whiteLabelThemeSelector } from 'entities/whiteLabels';

import { customPartnerThemePalette } from '../../config';
import { getThemeColors } from '../../lib/getThemeColors';
import { CustomThemePalette } from '../CustomThemePalette';

interface IWLTheme {
  dataThemeName: ThemeNames;
}

export const WLTheme = ({ dataThemeName }: IWLTheme) => {
  const themePalette = useAppSelector(whiteLabelThemeSelector);
  const whiteLabelAffId = useAppSelector(whiteLabelAffIdSelector);

  const colorsPalette = useMemo(() => getThemeColors(themePalette, whiteLabelAffId), [themePalette, whiteLabelAffId]);

  const customThemePaletteStyles = useMemo(
    () => (typeof whiteLabelAffId === 'number' ? customPartnerThemePalette[whiteLabelAffId] : null),
    [whiteLabelAffId],
  );

  if (customThemePaletteStyles) {
    return <CustomThemePalette styles={customThemePaletteStyles} />;
  }

  if (colorsPalette) {
    return (
      <WLThemeStylesWidget
        dataThemeName={dataThemeName}
        colors={colorsPalette}
      />
    );
  }

  return null;
};
